const BASE = 'APP_',
BASE_MODAL = BASE + 'MODAL_',
BASE_WALKTHROUGH = BASE + 'WALKTHROUGH_',
WALKTHROUGH_TOOLBAR =  BASE_WALKTHROUGH + 'TOOLBAR_';

/**
 * @name LOAD
 * @constant
 * @string
 * @description Used to tell the app to load a board
 */
export const LOAD = BASE + 'LOAD';

/**
 * @name WALKTHROUGH_END
 * @constant
 * @type string
 * @description Ends the walkthrough
 */
export const WALKTHROUGH_END = BASE_WALKTHROUGH + '_END';

/**
 * @name WALKTHROUGH_START
 * @constant
 * @type string
 * @description Initiates the walkthrough
 */
export const WALKTHROUGH_START = BASE_WALKTHROUGH + '_START';

/**
 * @name WALKTHROUGH_TOOLBAR_CLOSE
 * @constant
 * @type string
 * @description Forces the toolbar closed for the user
 */
export const WALKTHROUGH_TOOLBAR_CLOSE = WALKTHROUGH_TOOLBAR + '_CLOSE';

/**
 * @name WALKTHROUGH_TOOLBAR_OPEN
 * @constant
 * @type string
 * @description Forces the toolbar open for the user
 */
export const WALKTHROUGH_TOOLBAR_OPEN = WALKTHROUGH_TOOLBAR + '_OPEN';

/**
 * @name MODAL_TOGGLE
 * @constant
 * @string
 * @description Used to show or dismiss a modal
 */
export const MODAL_TOGGLE = BASE_MODAL + 'TOGGLE';